import { Skeleton } from '@/components/ui/skeleton';

export function CarCardSkeleton() {
  return (
    <div className="bg-card rounded-xl shadow-card overflow-hidden">
      {/* Image skeleton */}
      <Skeleton className="aspect-[16/10] w-full" />
      
      {/* Content */}
      <div className="p-4 space-y-3">
        {/* Title */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-6 w-48" />
        </div>

        {/* Quick Specs */}
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-14" />
        </div>

        {/* Drivetrain */}
        <Skeleton className="h-3 w-24" />

        {/* Price */}
        <div className="pt-2 border-t border-border space-y-1">
          <Skeleton className="h-3 w-10" />
          <Skeleton className="h-7 w-28" />
        </div>
      </div>
    </div>
  );
}

interface CarCardGridSkeletonProps {
  count?: number;
}

export function CarCardGridSkeleton({ count = 6 }: CarCardGridSkeletonProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <CarCardSkeleton key={i} />
      ))}
    </div>
  );
}
